import SingletonStore from 'annuity_lab/services/data/base/singleton_store.js';

const PERSISTENCE_KEY = 'recent_tool_';

export default class RecentTool extends SingletonStore {
    constructor(userId) {
        super(`${PERSISTENCE_KEY}${userId}`);
    }
}
